import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (token) {
      // Décoder le payload pour récupérer les infos enseignant
      const payload = JSON.parse(atob(token.split('.')[1]));
      localStorage.setItem('token', token);
      localStorage.setItem('enseignant', JSON.stringify({
        id:    payload.id,
        nom:   payload.nom,
        email: payload.email,
      }));
      navigate('/dashboard', { replace: true });
    } else {
      navigate(`/login?error=${encodeURIComponent(error || 'Connexion ENT échouée')}`, { replace: true });
    }
  }, [navigate, params]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 16
    }}>
      <div className="spinner-border text-primary"></div>
      <p className="text-muted">Connexion via ENT en cours...</p>
    </div>
  );
}
